var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectRoofSlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 427319378",
    clipPath: "url(#clip0_2155_379)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4989 9.59232L8.53769 7.60812C8.50601 7.59804 8.47145 7.59229 8.4369 7.59229C8.40234 7.59229 8.36634 7.59804 8.33034 7.60812C8.15467 7.66572 8.0582 7.85291 8.1158 8.03434L10.0971 13.974C10.1216 14.0575 10.1777 14.1338 10.2613 14.1784C10.3117 14.2058 10.3664 14.2188 10.4197 14.2188C10.5406 14.2188 10.6572 14.1525 10.7148 14.0402L11.6292 12.2993L13.2894 13.9624L13.3081 13.9783C13.3729 14.0431 13.4579 14.0748 13.5443 14.0748C13.6306 14.0748 13.7156 14.0431 13.7804 13.9783L14.4874 13.2684C14.6184 13.1374 14.6184 12.9286 14.4874 12.7961L12.8085 11.1201L14.5464 10.2057C14.6227 10.1625 14.6803 10.1006 14.7077 10.0128C14.7682 9.8371 14.6703 9.64848 14.4989 9.59232ZM12.3794 10.3051L11.3527 10.845L10.8142 11.8703L10.542 12.3901L9.36132 8.85221L12.9006 10.0301L12.3794 10.3051Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 4753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 594",
    d: "M15.4143 9.18783L11.2946 0.779541L0.783936 5.49021L5.16777 14.405L8.3125 12.6873",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2155_379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0991211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectRoofSlab);
export default __webpack_public_path__ + "static/media/select-roof-slab.11b1152acede0f5369c1fe73f7bf3b59.svg";
export { ForwardRef as ReactComponent };